__turbopack_context__.v({
  "List": "QarhkG_List",
  "ListItemDescription": "QarhkG_ListItemDescription",
  "ListItemMain": "QarhkG_ListItemMain",
});
